"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var fudouActiveApi = _interopRequireWildcard(require("@/api/fudouActiveApi.js"));
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var storeApi = _interopRequireWildcard(require("@/api/store"));
var companyApi = _interopRequireWildcard(require("@/api/companyApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      supplierLists: [],
      addresData: [],
      initLoading: false
    };
  },
  mounted: function mounted() {
    this.getCityList();
  },
  methods: {
    throttle: _throttle.default,
    openInit: function openInit(tagDetails, initSupplierId, initSupplierName) {
      var _this = this;
      this.pram = {};
      this.searchSupplier(initSupplierName || '');
      this.$set(this.pram, 'supplierId', initSupplierId || null);
      if (!(tagDetails !== null && tagDetails !== void 0 && tagDetails.id)) {
        this.visible = true;
        return;
      }
      ;
      this.initLoading = true;
      companyApi.detailHouse(tagDetails.id).then(function (res) {
        _this.initLoading = false;
        _this.pram = _objectSpread({}, res || {});
        _this.visible = true;
      });
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var _ref = _this2.pram || {},
          id = _ref.id;
        companyApi[id ? 'updateHouse' : 'createHouse'](_this2.pram).then(function (data) {
          // companyApi[id ? 'updateHouse' : 'cardAddArticle'](this.pram).then((data) => {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    searchSupplier: function searchSupplier() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.supplierLists = [];
      storeApi.getSupplierApi({
        keyword: keyword
      }).then(function (res) {
        _this3.supplierLists = res || [];
      });
    },
    handleSupplierSearch: function handleSupplierSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.searchSupplier(data);
      }, 300)();
    },
    getCityList: function getCityList() {
      var _this5 = this;
      this.addresData = [];
      logistics.treeLevel3().then(function (res) {
        _this5.addresData = res || [];
      });
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this6 = this;
      this.$modalUpload(function (img) {
        _this6.$set(_this6.pram, dataIndex, img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg(dataIndex) {
      this.$set(this.pram, dataIndex, '');
    }
  }
};